import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import { space, SpaceProps } from 'styled-system'

type AlertBannerVariant = 'success' | 'warning' | 'error' | 'info' | 'purple'

const getBannerContent = (variant: AlertBannerVariant) => {
  switch (variant) {
    case 'success': {
      return {
        textColor: palette.success.green700,
        backgroundColor: palette.success.green200,
        borderColor: palette.success.green700,
      }
    }
    case 'warning': {
      return {
        textColor: palette.warning.yellow700,
        backgroundColor: palette.warning.yellow200,
        borderColor: palette.warning.yellow700,
      }
    }
    case 'error': {
      return {
        textColor: palette.error.red700,
        backgroundColor: palette.error.red200,
        borderColor: palette.error.red700,
      }
    }
    case 'info': {
      return {
        textColor: palette.black,
        backgroundColor: palette.grey.grey200,
        borderColor: palette.grey.grey700,
      }
    }
    case 'purple': {
      return {
        textColor: palette.secondary.purple700,
        backgroundColor: palette.secondary.purple100,
        borderColor: palette.secondary.purple600,
      }
    }
  }
}

const Container = styled.div<{ variant: AlertBannerVariant } & SpaceProps>`
  width: 100%;
  background-color: ${(props) => {
    switch (props.variant) {
      case 'success': {
        return getBannerContent(props.variant).backgroundColor
      }
      case 'warning': {
        return getBannerContent(props.variant).backgroundColor
      }
      case 'error': {
        return getBannerContent(props.variant).backgroundColor
      }
      case 'info': {
        return getBannerContent(props.variant).backgroundColor
      }
      case 'purple': {
        return getBannerContent(props.variant).backgroundColor
      }
    }
  }};
  border-radius: 0.25rem;
  border-left: 0.25rem solid
    ${(props) => getBannerContent(props.variant).borderColor};
  padding: 1rem;

  ${space}
`

const BannerIconMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`

interface AlertBannerProps extends SpaceProps {
  variant: AlertBannerVariant
  title: string
  message: string
}

const AlertBanner = React.memo((props: AlertBannerProps) => {
  const { variant, title, message } = props

  return (
    <Container variant={variant} {...props}>
      <Text variant='action3' marginBottom='0.5rem'>
        {title}
      </Text>
      <BannerIconMessageContainer>
        <Text variant='action4' textColor={getBannerContent(variant).textColor}>
          {message}
        </Text>
      </BannerIconMessageContainer>
    </Container>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  AlertBanner.displayName = 'AlertBanner'
}
export default AlertBanner
